var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1748677452438,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14894,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M603.94 522.46s361.71 181.22 292.17 478.71c0 0-329.32-60.6-292.17-478.71zM553.14 448.4S647.27 54.94 952.78 54.94c0 0 15.95 334.46-399.64 393.46z",
    fill: "#84C584",
    "p-id": 14895
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M968.73 389.4c-102-136-228.2-76.65-312.16-8.37C819 94.72 580.5-84.26 381.61 78.54c-119.84 98.1-76.82 209.46-13.92 289.69C89.35 195.48-98.66 425.75 55.27 631c98.61 131.5 219.88 80.36 303.71 15.1-160.72 281.78 74.29 460.78 274 301.18 131.35-105 71-227.75 1.08-309.6 290.43 199.5 492.66-37.59 334.67-248.28z",
    fill: "#DABEDC",
    "p-id": 14896
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M824.63 437.3c-68.77-91.7-153.89-51.69-210.52-5.64 109.58-193.09-51.3-313.79-185.42-204-80.82 66.16-51.81 141.23-9.39 195.34-187.71-116.5-314.5 38.8-210.69 177.22 66.5 88.68 148.28 54.19 204.81 10.18-108.39 190 50.11 310.75 184.8 203.12 88.58-70.79 47.85-153.6 0.73-208.79C794.8 739.28 931.18 579.39 824.63 437.3z",
    fill: "#DABEDC",
    "p-id": 14897
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M495.1 465.31a22.74 22.74 0 1 1-18.61-26.22 22.74 22.74 0 0 1 18.61 26.22z",
    fill: "#FFEE1D",
    "p-id": 14898
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M553.14 471.14m-22.73 0a22.73 22.73 0 1 0 45.46 0 22.73 22.73 0 1 0-45.46 0Z",
    fill: "#FFEE1D",
    "p-id": 14899
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M538.73 538.36A22.73 22.73 0 1 1 521.9 511a22.73 22.73 0 0 1 16.83 27.36z",
    fill: "#FFEE1D",
    "p-id": 14900
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M437.09 532.6m-22.73 0a22.73 22.73 0 1 0 45.46 0 22.73 22.73 0 1 0-45.46 0Z",
    fill: "#FFEE1D",
    "p-id": 14901
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M622.39 545.52a22.74 22.74 0 1 1-22.73-22.73 22.74 22.74 0 0 1 22.73 22.73z",
    fill: "#FFEE1D",
    "p-id": 14902
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M546.34 599.71m-22.73 0a22.73 22.73 0 1 0 45.46 0 22.73 22.73 0 1 0-45.46 0Z",
    fill: "#FFEE1D",
    "p-id": 14903
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M495.42 599.71A22.74 22.74 0 1 1 472.69 577a22.74 22.74 0 0 1 22.73 22.71z",
    fill: "#FFEE1D",
    "p-id": 14904
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower4);
export default __webpack_public_path__ + "static/media/flower4.bb7cb8ab7073d2f93d21961335d3aa19.svg";
export { ForwardRef as ReactComponent };